import styled from "styled-components"

export const StyledRegistrationForm = styled.div`
  text-align: left;
  border: none;
  background-color: transparent;
  border-radius: 0;
  padding: 0;
  max-width: 100%;
  width: 100%;
  margin: 0;
  line-height: 1.5;
  font-size: 14px;

  @media (max-width: 768px) {
    padding: 0;
  }
`

export const StyledSingleWaiverSection = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  margin-bottom: 8px;
  padding: 12px 14px;
  background-color: #ffffff;
  width: 100%;
  box-sizing: border-box;

  h6 {
    margin: 0 0 4px 0;
    font-size: 14px;
    font-weight: 600;
  }

  .waiver-section-body {
    margin-bottom: 8px;
  }
`
export const StyledWaiver = styled.div`
  text-align: left;
  border-top: 1px solid #e0e0e0;
  margin-bottom: 8px;
  padding: 10px 4px 4px 4px;
  width: 100%;
  box-sizing: border-box;

  .waiver-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    margin-bottom: 4px;
  }

  .waiver-title {
    font-size: 16px;
    font-weight: 600;
    margin-right: 8px;
  }

  .waiver-meta {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
  }

  .waiver-body {
    padding: 0 4px 4px 4px;
    line-height: 1.6;
    font-size: 14px;

    p {
      margin: 0 0 8px 0;
    }

    ul,
    ol {
      margin: 0 0 8px 20px;
    }
  }
`
